import type { GetOrderRequest, GetOrdersRequest, GetUserOrdersRequest } from './types';

export const ORDER_QUERY_KEYS = {
  default: () => ['order'] as const,
  getOrder: (params: GetOrderRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrder', params] as const,
  getOrders: (params?: GetOrdersRequest) => [...ORDER_QUERY_KEYS.default(), 'getOrders', params] as const,
  getUserOrders: (params: GetUserOrdersRequest) => [...ORDER_QUERY_KEYS.default(), 'getUserOrders', params] as const,
  associateOrder: () => [...ORDER_QUERY_KEYS.default(), 'associateOrder'] as const,
};

